/**
 * L2-R6: moved to @miq/platform (services/user-preferences.ts). This shim keeps the old
 * import path working; new code should import from '@miq/platform'.
 *
 * `UserPreferencesHelper` had already moved in L2-P3 (services/user-preferences-helper.ts); the two
 * readers below were the last thing keeping this file in the app, and they were the reports remote's
 * most-used host seam (15 import sites).
 */
export { getGlobalDateDisplayFormat, isYearlyPreference, UserPreferencesHelper } from '@miq/platform';
